// popup
// blurs background and shows popup box
//
// .full-background-image__popup
//
// Author: tobias.wolf@wagnerwagner.de


(function () {
  function Popup(element) {
    // elements
    let linkElements = [];
    const fullBackgroundImageElement = element.parentElement.parentElement;
    const ce_imageElement = fullBackgroundImageElement.querySelector('.ce_image');

    // variables
    const { id } = element;
    const self = this;
    const height = element.offsetHeight;
    let fullBackgroundImageClickEventListener;

    // functions
    function init() {
      linkElements = document.querySelectorAll(`a[href$="${id}"]`);
      if (location.hash.substr(1) !== id) {
        close();
        element.style.transitionDuration = '0s';
        element.offsetHeight;
        element.style.transitionDuration = null;
        if (!window.matchMedia('max-width: 927px').matches) {
          ce_imageElement.classList.remove('is-blurred');
        }
      } else {
        open();
      }
      for (let i = 0; i < linkElements.length; i++) {
        linkElements[i].addEventListener('click', handleClick);
      }
      setButtonDirection();
    }
    function setButtonDirection() {
      for (let i = 0; i < linkElements.length; i++) {
        const linkElement = linkElements[i];
        if (window.matchMedia('(max-width: 927px)').matches) {
          if (linkElement.classList.contains('is-active')) {
            linkElement.classList.remove('button_down');
            linkElement.classList.add('button_up');
          } else {
            linkElement.classList.remove('button_up');
            linkElement.classList.add('button_down');
          }
        } else {
          linkElement.classList.remove('button_down');
          linkElement.classList.remove('button_up');
        }
      }
    }
    function open() {
      element.classList.remove('is-close');
      if (window.matchMedia('(max-width: 927px)').matches) {
        element.style.height = `${height}px`;
        element.addEventListener('transitionend', () => {
          element.style.transitionDuration = '0s';
          element.style.height = null;
          element.offsetHeight;
          element.style.transitionDuration = null;
        });
      } else {
        setTimeout(() => {
          ce_imageElement.classList.add('is-blurred');
        }, 10);
      }
      fullBackgroundImageClickEventListener = fullBackgroundImageElement.addEventListener('click', handleFullBackgroundImageElementClick);
      setLinkToInactive();
    }
    function close() {
      let returnValue = false;
      if (!element.classList.contains('is-close')) {
        returnValue = true;
        if (window.matchMedia('(max-width: 927px)').matches) {
          element.style.transitionDuration = '0s';
          element.style.height = `${element.offsetHeight}px`;
          element.offsetHeight;
          element.style.transitionDuration = null;
          element.style.height = null;
        } else {
          ce_imageElement.classList.remove('is-blurred');
        }
        element.classList.add('is-close');
        setTimeout(setLinkToActive, TRANSITION_DURATION * 2);
      }
      return returnValue;
    }
    function setLinkToInactive() {
      for (let i = 0; i < linkElements.length; i++) {
        const linkElement = linkElements[i];
        linkElement.classList.add('is-active');
        setButtonDirection();
      }
    }
    function setLinkToActive() {
      for (let i = 0; i < linkElements.length; i++) {
        const linkElement = linkElements[i];
        linkElement.classList.remove('is-active');
        setButtonDirection();
      }
    }
    function handleHashChange() {
      if (location.hash.substr(1) === id
          && element.classList.contains('is-close')) {
        open();
      } else if (!element.classList.contains('is-close')) {
        close();
      }
    }
    function handleFullBackgroundImageElementClick(e) {
      if (e.target === fullBackgroundImageElement) {
        close();
        window.history.replaceState(null, null, location.pathname);
      }
    }
    function handleClick() {
      if (element.classList.contains('is-close')) {
        open();
        closeOthers(self);
      } else {
        close();
        window.history.replaceState(null, null, location.pathname);
      }
    }
    function handleWindowResize() {
      setButtonDirection();
    }

    // event listener
    window.addEventListener('hashchange', handleHashChange);
    window.addEventListener('resize', handleWindowResize);

    // init
    init();

    // public variables
    this.close = close;
  }

  // elements
  const elements = document.querySelectorAll('.full-background-image__popup');

  // variables
  const popups = [];

  // functions
  function init() {
    for (let i = 0; i < elements.length; i++) {
      popups.push(new Popup(elements[i]));
    }
  }
  function closeOthers(exceptPopup) {
    for (let i = 0; i < popups.length; i++) {
      const popup = popups[i];
      if (exceptPopup !== popup) {
        popup.close();
      }
    }
  }

  // init instances
  init();
}());
